import { render, staticRenderFns } from "./BotaoRemanejar.vue?vue&type=template&id=148b182f"
import script from "./BotaoRemanejar.vue?vue&type=script&lang=js"
export * from "./BotaoRemanejar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports